import { render, staticRenderFns } from "./BucketEmail.vue?vue&type=template&id=7c70c4c0&scoped=true"
import script from "./BucketEmail.vue?vue&type=script&lang=ts"
export * from "./BucketEmail.vue?vue&type=script&lang=ts"
import style0 from "./BucketEmail.vue?vue&type=style&index=0&id=7c70c4c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70c4c0",
  null
  
)

export default component.exports